enum FileSystemObjectType
{
	Directory = 1,
	File = 2,
	Image = 3,
	Video = 4
}

export default FileSystemObjectType;